var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWallet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4179 4.5H4.58214C4.16253 4.5 3.76011 4.67293 3.4634 4.98076C3.16669 5.28859 3 5.7061 3 6.14144V11.8586C3 12.2939 3.16669 12.7114 3.4634 13.0192C3.76011 13.3271 4.16253 13.5 4.58214 13.5H13.4179C13.8375 13.5 14.2399 13.3271 14.5366 13.0192C14.8333 12.7114 15 12.2939 15 11.8586V6.14144C15 5.7061 14.8333 5.28859 14.5366 4.98076C14.2399 4.67293 13.8375 4.5 13.4179 4.5ZM13.9574 7.92349H10.7746C10.6591 7.92443 10.547 7.96396 10.4549 8.0362C10.3627 8.10843 10.2955 8.20955 10.2631 8.32455C10.1817 8.6065 10.0149 8.85371 9.78734 9.02947C9.5598 9.20522 9.28368 9.30016 9 9.30016C8.71632 9.30016 8.4402 9.20522 8.21266 9.02947C7.98511 8.85371 7.81828 8.6065 7.73693 8.32455C7.70452 8.20955 7.63725 8.10843 7.54511 8.0362C7.45297 7.96396 7.34085 7.92443 7.22537 7.92349H4.04263V6.43854C4.04263 6.21129 4.12964 5.99335 4.28452 5.83267C4.4394 5.67198 4.64947 5.58171 4.86851 5.58171H13.132C13.3511 5.58171 13.5611 5.67198 13.716 5.83267C13.8709 5.99335 13.9579 6.21129 13.9579 6.43854L13.9574 7.92349Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet.f337e2b794f12a458e2e0d16a1b72701.svg";